<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "ReadingWidget",
    components: {
        RawData,
    },
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        withButtons: {
            type: Boolean,
            default: false,
        },
        service: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        postReading(reading) {
            this.$emit("postReading", reading);
        },
        updateReading(reading) {
            this.$emit("updateReading", reading);
        },
        deleteReading(reading) {
            this.$emit("deleteReading", reading);
        },
        printReading(reading) {
            this.$emit("printReading", reading);
        },
    },
}
</script>
<template>
    <div>
        <div v-for="(reading, index) in tableData" :key="index" class="reading-item mb-3">
            <RawData :data="reading" v-if="$store.state.decrypt.isAdmin()"/>
            <div>Reading Date: {{ formatDateShort(new Date(reading.readingDate)) }}</div>
            <div>Inclusive Dates: {{ reading.inclusiveDate }}</div>
            <div class="reading text-white mt-2">Used: <span class="text-">{{formatNumber(reading.readingAmount)}} {{service ? service.unit : ''}}</span></div>
            <small class="text-right d-block font-size-15">Current Reading: <span class="text-white font-weight-bold border px-2 py-1 rounded">{{formatNumber(reading.meterReading)}}</span> <span  v-if="reading.previousSubscriberMeterReading">| Previous Reading: <span class="text-orange font-weight-bold border px-2 py-1 rounded">{{formatNumber(reading.previousSubscriberMeterReading)}}</span></span></small>
            <div v-if="reading.remarks" class="text-right mt-2"><i>({{reading.remarks}})</i></div>
            <div class="buttons d-flex gap-1 hoverable">
                <button type="button" class="btn btn-xs btn-purple" @click="printReading(reading)">
                    <i class="bx bx-printer"></i> Print
                </button>
                <template v-if="withButtons">
                    <button type="button" class="btn btn-xs btn-success" @click="postReading(reading)">
                        <i class="bx bx-check"></i> Post
                    </button>
                    <button type="button" class="btn btn-xs btn-primary" @click="updateReading(reading)">
                        <i class="bx bx-edit"></i> Update
                    </button>
                    <button type="button" class="btn btn-xs btn-danger" @click="deleteReading(reading)">
                        <i class="bx bx-trash"></i> Delete
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>